<template>
  <f7-page login-screen id="reset-password-screen">
    <f7-navbar back-link="Terug"></f7-navbar>
    <f7-login-screen-title>
      <img src="/static/images/logos/private-gym/logo-cropped.svg" style="width: 80%; max-width:250px; opacity: 1;" class="m-3 w-80">
    </f7-login-screen-title>
    <f7-list form class="list-strong list-outline list-dividers">
      <f7-list-input
          type="text"
          name="email"
          placeholder="Jouw email adres"
          :value="email"
          @input="email = $event.target.value"
      ></f7-list-input>
      <f7-list-input
          type="text"
          name="token"
          placeholder="Je reset token (vanuit de mail)"
          :value="token"
          @input="token = $event.target.value"
      ></f7-list-input>
      <f7-list-input
          type="password"
          name="password"
          placeholder="Nieuw wachtwoord"
          :value="password"
          @input="password = $event.target.value"
      ></f7-list-input>
      <f7-list-input
          type="password"
          name="password_confirmation"
          placeholder="Wachtwoord (nogmaals)"
          :value="password_confirmation"
          @input="password_confirmation = $event.target.value"
      ></f7-list-input>
    </f7-list>
    <f7-list class="list-strong list-outline list-dividers">
      <f7-list-button @click="resetPassword">Opslaan</f7-list-button>
      <f7-block-footer>
<!--          Je ontvangt een link om je wachtwoord te resetten. Ontvang je deze email niet? Mail dan even naar support@privategym.nl-->
<!--          <br/>-->
        <f7-link href="/auth/forgot-password">Klik hier om een nieuwe reset link aan te vragen</f7-link>
        <f7-link href="/">Klik hier om in te loggen</f7-link>
      </f7-block-footer>
    </f7-list>
  </f7-page>
</template>

<script>

import { f7, f7ready } from 'framework7-vue';

export default {
  components: {},

  props: {
    f7router: Object,
    f7route: Object,
  },

  mixins: [],

  data: function () {
    return {
      email: '',
      token: '',
      password: '',
      password_confirmation: '',
    };
  },

  computed: {
    current_user_has_token() {
      return this.$store.getters['current_user/token'].length > 0;
    }
  },

  created() {
    //
  },

  mounted() {
    if(typeof this.f7route.query.token !== 'undefined') {
      this.token = this.f7route.query.token;
    }
    if(typeof this.f7route.query.email !== 'undefined') {
      this.email = this.f7route.query.email;
    }
  },

  methods: {
    resetPassword() {
      this.$store.dispatch('current_user/reset_password', {
        email: this.email,
        token: this.token,
        password: this.password,
        password_confirmation: this.password_confirmation,
      }).then(response => {
        this.f7router.navigate('/auth/login')
      });
    }
  },

  watch: {
    //
  }
};
</script>
